import React from "react";
import { motion } from "framer-motion";

// Large animated golden cross SVG with shimmer + float + glow
export default function AnimatedCross({ className = "", size = 480 }) {
  return (
    <div className={`relative pointer-events-none ${className}`} style={{ width: size, height: size }}>
      <motion.div
        initial={{ opacity: 0, scale: 0.9 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 2, ease: "easeOut" }}
        className="cross-float cross-glow w-full h-full"
      >
        <svg
          viewBox="0 0 200 200"
          xmlns="http://www.w3.org/2000/svg"
          className="w-full h-full"
          aria-hidden="true"
        >
          <defs>
            <linearGradient id="goldGrad" x1="0%" y1="0%" x2="100%" y2="100%">
              <stop offset="0%" stopColor="#8a6e15" />
              <stop offset="35%" stopColor="#D4AF37" />
              <stop offset="55%" stopColor="#FFE9A6" />
              <stop offset="75%" stopColor="#D4AF37" />
              <stop offset="100%" stopColor="#8a6e15" />
            </linearGradient>
            <linearGradient id="shimmerMask" x1="-50%" y1="0%" x2="150%" y2="0%">
              <stop offset="0%" stopColor="#D4AF37" />
              <stop offset="50%" stopColor="#FFFAEC" />
              <stop offset="100%" stopColor="#D4AF37" />
              <animate attributeName="x1" from="-150%" to="50%" dur="6s" repeatCount="indefinite" />
              <animate attributeName="x2" from="-50%" to="150%" dur="6s" repeatCount="indefinite" />
            </linearGradient>
          </defs>
          {/* vertical bar */}
          <rect x="90" y="20" width="20" height="160" fill="url(#shimmerMask)" />
          {/* horizontal bar */}
          <rect x="55" y="65" width="90" height="20" fill="url(#shimmerMask)" />
          {/* subtle outline */}
          <rect x="90" y="20" width="20" height="160" fill="none" stroke="rgba(255,233,166,0.35)" strokeWidth="0.5" />
          <rect x="55" y="65" width="90" height="20" fill="none" stroke="rgba(255,233,166,0.35)" strokeWidth="0.5" />
        </svg>
      </motion.div>
    </div>
  );
}
